// extracted by mini-css-extract-plugin
module.exports = {"main":"Divider_main__2Qkbo","textNoHR":"Divider_textNoHR__2JlYO","text":"Divider_text__brEyh","icon":"Divider_icon__n6jtk","hr":"Divider_hr__zq2AV"};